import Layout from "@/layouts/default.vue";

export default [
    {
        path: "/system",
        name: "system",
        meta: {
            title: "系统配置",
            icon: "setting",
        },
        component: Layout,
        redirect: "/system/system-conf-list",
        children: [
            {
                path: "",
                name: "system-conf-list",
                component: () => import("@/views/system/global-conf.vue"),
                meta: {
                    title: "全局配置",
                    icon: "global",
                    permission: "manage_system_config",
                },
            },
            {
                path: "template",
                name: "email-template",
                component: () => import("@/views/notification/template/email/index.vue"),
                meta: {
                    title: "邮件模板",
                    icon: "template-email",
                    permission: "manage_email_template",
                },
            },
            {
                path: "template/detail",
                name: "email-template-detail",
                hidden: true,
                component: () => import("@/views/notification/template/email/detail.vue"),
                meta: {
                    title: "邮件模板",
                    icon: "template-email",
                    permission: "manage_email_template",
                },
            },
            {
                path: "notice",
                name: "system-notice",
                component: () => import("@/views/system/announcement"),
                meta: {
                    title: "公告管理",
                    icon: "notice",
                    group: 512,
                },
            },
            {
                path: "wechat/menu",
                name: "wechat-menu",
                component: () => import("@/views/system/wechat/menu.vue"),
                meta: {
                    title: "微信菜单",
                    icon: "wxmp-menu",
                    permission: ["manage_wxmenu", "manage_wxmp_menu"],
                },
            },
            // {
            //     path: "wechat/conditional-menu",
            //     name: "wechat-conditional-menu",
            //     component: () => import("@/views/system/wechat/conditional-menu.vue"),
            //     meta: {
            //         title: "个性菜单",
            //         icon: "wxmp-conditional-menu",
            //         permission: "manage_wxmp_menu",
            //     },
            // },
            // {
            //     path: "wechat/material",
            //     name: "wechat-material",
            //     component: () => import("@/views/system/wechat/material.vue"),
            //     meta: {
            //         title: "微信素材",
            //         icon: "wxmp-material",
            //         permission: "manage_wxmp_material",
            //     },
            // },
        ],
    },
];
